import {classNames} from "@utils/class-names";
import React from "react";
import {ReactComponent as ItalicIcon} from "@assets/icons/italic.svg";

interface ItalicButtonProps {
    isActive: boolean;
    onFormat: (command: string) => void;
}

const ItalicButton = (props: ItalicButtonProps) => {
    const {isActive, onFormat} = props;

    return (
        <button
            type="button"
            onClick={() => onFormat("italic")}
            className={classNames(
                "px-2 w-10 h-10 hover:bg-on-surface/5 rounded-full flex items-center justify-center",
                isActive && "bg-primary/10 text-primary"
            )}
            title="Kursywa"
        >
            <ItalicIcon className={isActive ? "text-primary" : ""}/>
        </button>
    )
}

export default ItalicButton
